import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, styled, ToggleButton,
    ToggleButtonGroup,

    Typography,
} from "@mui/material";

import MuiToggleButton from "@mui/material/ToggleButton";
import AttributBdnd from "./AttributBdnb";
import AttributDpeV2 from "./AttributDpeV2";
import AttributDpeTerV2 from "./AttributDpeTerV2";
import AttributDpeV1 from "./AttributDpeV1";
import AttributDvf from "./AttributDvf";
import {PDFExport} from "@progress/kendo-react-pdf";
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import {getNbEtage} from "../svc/Utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HeaderDetails, {getAddresse2, getAddresse3} from "./v2/HeaderDetails";
import BatimentsDetails from "./v2/BatimentsDetails";
import RNCDetails from "./v2/RNCDetails";
import EnvironementDetails from "./v2/EnvironementDetails";
import DpeV2Details from "./v2/DpeV2Details";
import DVFDetails from "./v2/DVFDetails";
import DpeV1Details from "./v2/DpeV1Details";
import DpeTerDetails from "./v2/DpeTerDetails";
import DpeDetails from "./v2/DpeDetails";
import ProprioDetails from "./v2/ProprioDetails";
import DpeV2ImmeubleDetails from "./v2/DpeV2ImmeubleDetails";

export function getStringFromMinMax(value, max) {
    if (value && value.min && value.max) {
        if (value.min === value.max) {
            return Math.ceil(value.min);
        } else {
            return Math.ceil(value.min) + " - " + Math.ceil(value.max);
        }
    }
    return "inconnue"
}

export function getDataInStringDenom(string) {
    if (string && string !== "NaN" && string !== NaN) {
        return string;
    }
    return "Pas de détails disponibles en base de données concernant la société ou la collectivité propriétaire";
}

export function getDataInString(string) {
    if (string && string !== "NaN" && string !== NaN) {
        return string;
    }
    return "Pas de données disponible"
}

export function getDataInStringShort(string) {
    if (string) {
        return string;
    }
    return "NA"
}

export function getDataInStringShort2(string) {
    if (string) {
        return string;
    }
    return "NA"
}


export function getNumberToString(string) {
    if (string) {
        return Math.floor(Number(string));
    }
    return "NA"
}

export function getNumberToString2(string) {
    if (string) {
        return Math.ceil(Number(string));
    }
    return "NA"
}

export function getStringFromObejcts(values) {
    let res = "";
    Object.keys(values).map((key, i) => {
        if (i > 0) res += ", "
        res += getTypeEq(key)
    })

    return res
}

export function computeSurfUtile(hauteurMean, sgeomGroupe, annee) {
    if (!hauteurMean || !sgeomGroupe) {
        return "";
    }
    let nbEtage = getNbEtage(hauteurMean, annee);
    return Math.ceil(nbEtage * Number(sgeomGroupe) * 0.9)
}

function replaceAll(string, search, replace) {
    if (string) {
        return string.split(search).join(replace);
    }
}

export function getTypeEq(ltypeEquipement) {
    if (ltypeEquipement) {
        let result = ltypeEquipement
        if (result && result !== "") {

            result = replaceAll(result, "{", "");
            result = replaceAll(result, "\"", "")
            result = replaceAll(result, "}", "");
            result = replaceAll(result, "Annexe", "");
        }
        return getDataInString(result);
    }
    return "";
}

export function getAddresse(selectedItem) {
    let addresse = "";
    if (selectedItem.metadonnees[0].numero) {
        addresse = addresse + " " + selectedItem.metadonnees[0].numero;
    }
    if (selectedItem.metadonnees[0].rep) {
        addresse = addresse + " " + selectedItem.metadonnees[0].rep;
    }

    if (selectedItem.metadonnees[0].type_voie) {
        addresse = addresse + " " + selectedItem.metadonnees[0].type_voie;
    }
    if (selectedItem.metadonnees[0].nom_voie) {
        addresse = addresse + " " + selectedItem.metadonnees[0].nom_voie;
    }
    if (selectedItem.metadonnees[0].libelle_commune) {
        addresse = addresse + ", " + selectedItem.metadonnees[0].libelle_commune;
    }


    return addresse;
}

export default function RightAccordion({selectedItem}) {
    const pdfExportComponent = React.useRef(null);
    const exportPDFWithMethod = () => {
        pdfExportComponent.current.save();

    };

    function getFileName() {
        return `data_renov-${getAddresse3(selectedItem.metadonnees[0])}-${new Date().getFullYear()}`;

    }


    const [ready, setReady] = React.useState(false);
    const [pdf, setPdf] = React.useState(false);

    const delay = ms => new Promise(res => setTimeout(res, ms));

    const [v2, setV2] = React.useState(true);
    const [vue, setVue] = React.useState("batiment");
    React.useEffect(() => {
        if (pdf) {
            delay(800).then(() => {
                setReady(true);
            });
        }
    }, [pdf]);

    React.useEffect(() => {
        if (ready) {
            exportPDFWithMethod();
            delay(500).then(() => {
                setReady(false);
                setPdf(false);
            });
        }
    }, [ready]);

    const ToggleButton = styled(MuiToggleButton)({
        color: "#000000",
        backgroundColor: "#d2d2d2",

        "&.Mui-selected, &.Mui-selected:hover": {
            color: "white",
            backgroundColor: 'rgb(213,27,138)'
        }
    });

    function checkDvf(selectedItem) {
        let prix_m2_local_max = 0;
        let prix_m2_local_min = 0;
        let prix_m2_local_moyen = 0;
        let valeur_fonciere_max = 0;
        let valeur_fonciere_min = 0;
        let valeur_fonciere_moyenne = 0;
        if (selectedItem.metadonnees[0].prix_m2_local_max) {
            prix_m2_local_max = Number(selectedItem.metadonnees[0].prix_m2_local_max);
        }
        if (selectedItem.metadonnees[0].prix_m2_local_min) {
            prix_m2_local_min = Number(selectedItem.metadonnees[0].prix_m2_local_min);
        }
        if (selectedItem.metadonnees[0].prix_m2_local_moyen) {
            prix_m2_local_moyen = Number(selectedItem.metadonnees[0].prix_m2_local_moyen);
        }
        if (selectedItem.metadonnees[0].valeur_fonciere_max) {
            valeur_fonciere_max = Number(selectedItem.metadonnees[0].valeur_fonciere_max);
        }
        if (selectedItem.metadonnees[0].valeur_fonciere_min) {
            valeur_fonciere_min = Number(selectedItem.metadonnees[0].valeur_fonciere_min);
        }
        if (selectedItem.metadonnees[0].valeur_fonciere_moyenne) {
            valeur_fonciere_moyenne = Number(selectedItem.metadonnees[0].valeur_fonciere_moyenne);
        }


        return (!prix_m2_local_max && !prix_m2_local_min && !prix_m2_local_moyen && !valeur_fonciere_max && !valeur_fonciere_min && !valeur_fonciere_moyenne);

    }

    if (!selectedItem) {
        return (
            <Box sx={{width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                <CircularProgress/>
            </Box>)
    } else {

console.log(selectedItem)
        return (<Box sx={{width: "100%", height: "100%", zIndex: 99999}}>
            <Box>
                <Button sx={{
                    textAlign: "center",
                    background: "rgb(213,27,138)",
                    color: "white",
                    margin: 1,
                    "&:hover": {
                        backgroundColor: "rgb(176,12,111)"
                    },
                }}
                        onClick={() => {
                            setPdf(true);
                        }}>

                    <Typography sx={{display: "flex"}}>
                        <PdfIcon/>Export</Typography>
                </Button>

            </Box>
            {!pdf && <PDFExport scale={0.3} margin="0.8cm" forcePageBreak=".page-break" ref={pdfExportComponent}
                                paperSize="A4"
                                fileName={getFileName()}>

                <HeaderDetails selectedItem={selectedItem}/>
                <Box sx={{width: "95%"}}>
                    <ToggleButtonGroup
                        sx={{}}
                        value={vue}
                        exclusive={true}
                        onChange={(e, value) => {
                            if (value) {
                                setVue(value);
                            }
                        }}
                        fullWidth={true}
                    >
                        <ToggleButton value="batiment"
                        >
                            <Typography>
                                Batiments

                            </Typography>
                        </ToggleButton>
                        <ToggleButton value="prop" disabled={selectedItem.proprietaires.length === 0}>
                            <Typography>
                                Propriétaires personnes morales
                            </Typography>
                        </ToggleButton>
                        <ToggleButton value="copro" disabled={!selectedItem.metadonnees[0].l_nom_copro}>
                            <Typography>
                                Copropriétés
                            </Typography>
                        </ToggleButton>
                        <ToggleButton value="dpes"
                                      disabled={selectedItem.dpeTer.length === 0 && selectedItem.dpeV2.length === 0 && selectedItem.listOfDpeV1.length === 0}>
                            <Typography>
                                DPE
                            </Typography>
                        </ToggleButton>

                        <ToggleButton value="dvf"
                                      disabled={checkDvf(selectedItem)}>
                            <Typography>
                                DVF
                            </Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                <Box sx={{width: "95%"}}>
                    {vue === "batiment" && <BatimentsDetails selectedItem={selectedItem}/>}
                    {vue === "copro" && <RNCDetails selectedItem={selectedItem}/>}
                    {vue === "prop" && <ProprioDetails selectedItem={selectedItem}/>}
                    {vue === "dvf" && <DVFDetails selectedItem={selectedItem}/>}
                    {vue === "dpes" && <DpeDetails selectedItem={selectedItem}/>}

                </Box>
            </PDFExport>}
            {pdf && <PDFExport scale={0.3} margin="0.8cm" forcePageBreak=".page-break" ref={pdfExportComponent}
                               paperSize="A4"
                               fileName={getFileName()}>
                <HeaderDetails selectedItem={selectedItem}/>
                <BatimentsDetails selectedItem={selectedItem}/>
                <Box className="page-break"/>
                <ProprioDetails selectedItem={selectedItem}/>
                <RNCDetails selectedItem={selectedItem}/>
                <DVFDetails selectedItem={selectedItem}/>
                <Box className="page-break"/>
                {selectedItem.listOfDpesV2Immeuble.length > 0 && <DpeV2ImmeubleDetails selectedItem={selectedItem} details={true}/>}
                {selectedItem.dpeV2.length > 0 && <DpeV2Details selectedItem={selectedItem} details={true}/>}
                {selectedItem.dpeTer.length > 0 && <DpeTerDetails selectedItem={selectedItem}/>}
                {selectedItem.listOfDpeV1.length > 0 && <DpeV1Details selectedItem={selectedItem}/>}

            </PDFExport>}
        </Box>)
    }
}
